<template lang="html">
  <section class="section" v-if="skill">
    <h1>{{ skill.name }}</h1>
    <div>
      {{ skill.description }}
    </div>

  </section>
</template>

<script>
export default {
  data () {
    return {
      skill: null
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      this.$store.dispatch('skills/show', this.$route.params.skill)
        .then(resp => {
          this.skill = resp.data.data.attributes
        })
        .catch(error => {
          // TODO: Handle error
          console.log(error.response.status)
        })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
